module.exports = __webpack_public_path__ + "media/images/unauthorized-ad9acebdea70b63d4397b85c13d88d07.svg";